import React from "react";
import Icon, {
  AudioOutlined,
  AudioMutedOutlined,
  PushpinOutlined,
  CameraOutlined,
  DesktopOutlined,
  LikeOutlined,
  CloseSquareOutlined
} from "@ant-design/icons";

import micIcon from "../../assets/images/microphone-2.svg";
import micSlashIcon from "../../assets/images/microphone-slash.svg";

import cameraIcon from "../../assets/images/camera.svg";
import cameraSlashIcon from "../../assets/images/camera-slash.svg";

import volumeIcon from "../../assets/images/volume-high.svg";
import volumeSlashIcon from "../../assets/images/volume-slash.svg";

import monitorIcon from "../../assets/images/monitor.svg";

interface PropType {
  active: boolean;
  width?: string;
}

export const AudioIcon = ({ active, width }: PropType) => {
  return active ? (
    <img style={{ width: ( width ? width : "16px" ) }} src={micIcon} alt="micIcon" />
  ) : (
    <img style={{ width: ( width ? width : "16px" ) }} src={micSlashIcon} alt="micSlashIcon" />
  );
};

export const CloseSquareIcon = ({ active }: PropType) => {
  return active ? (
    <CloseSquareOutlined />
  ) : (
    <CloseSquareOutlined className="color-danger" />
  );
};

export const VideoIcon = ({ active }: PropType) => {
  return active ? (
    <img style={{ width: "16px" }} src={cameraIcon} alt="cameraIcon" />
  ) : (
    <img style={{ width: "16px" }} src={cameraSlashIcon} alt="cameraSlashIcon" />
  );
};

export const SoundIcon = ({ active }: PropType) => {
  return active ? (
    <img style={{ width: "16px" }} src={volumeIcon} alt="volumeIcon" />
  ) : (
    <img style={{ width: "16px" }} src={volumeSlashIcon} alt="volumeSlashIcon" />
  );
};

export const ShareIcon = ({ active }: PropType) => {
  return active ? (
    <img style={{ width: "16px" }} src={monitorIcon} alt="monitorIcon" />
  ) : (
    <img style={{ width: "16px" }} src={monitorIcon} alt="monitorIcon" />
  );
};

export const HandIcon = ({ active }: PropType) => {
  return active ? <LikeOutlined /> : <LikeOutlined className="color-danger" />;
};

export const PinIcon = ({ active }: PropType) => {
  return active ? <PushpinOutlined /> : <PushpinOutlined />;
};
